import { render } from "./Botanique1.vue?vue&type=template&id=04c3b16c&scoped=true"
import script from "./Botanique1.vue?vue&type=script&lang=js"
export * from "./Botanique1.vue?vue&type=script&lang=js"

import "./Botanique1.vue?vue&type=style&index=0&id=04c3b16c&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c3b16c"]])

export default __exports__